import AOS from "aos";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import "swiper/css/free-mode";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fontsource/jost";
import "@fontsource/lobster";
import "./assets/style/style.scss";
import "lite-youtube-embed";
import "animate.css";
import "react-toastify/dist/ReactToastify.css";
import { Routes,  Route,  useLocation,  useNavigate,  Navigate } from "react-router-dom";
import { lazy, useEffect, useRef } from "react";
import { ToastContainer } from "react-toastify";
import { RouteData } from "./routes/routes";

const TopHeader = lazy(() => import("./components/headercomponents/TopHeder"));
const BottamHeader = lazy(() =>  import("./components/headercomponents/BottamHeader"));
const Footer = lazy(() => import("./components/footercomponents/Footer"));
const ScrollToTop = lazy(() =>  import("./components/scrolltopcomponents/ScrollTop"));
const TawkTo = lazy(() => import("./components/chatcomponents/Message"));
const CallAndWhatsapp = lazy(() => import("./components/callcomponents/Call"));
const MobileFooter = lazy(() =>  import("./components/footercomponents/MobileFooter"));

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  // changes for forefully reload
  const lastPathname = useRef(location.pathname);   

  useEffect(() => {
    if (lastPathname.current !== location.pathname) {
      window.location.reload();
    }
  }, [location.pathname]);

  //end changes for forefully reload

  useEffect(() => {
    AOS.init({ duration: 3000 });
  }, []);

  useEffect(() => {
    if (location.pathname === "/") {
      localStorage.removeItem("city_name");
      localStorage.removeItem("country_name");
    }

  }, [location, navigate]);

  useEffect(() => {
    const pathRegex = /^\/\d{4}\/\d{2}\/\d{2}\/(.+)/;
    const match = location.pathname.match(pathRegex);

    if (match && match[1]) {
      const newPath = `/${match[1]}`;
      navigate(newPath, { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname !== "/" && /\/+$/.test(pathname)) {
      const newPath = pathname.replace(/\/+$/, "");
      navigate(newPath + location.search + location.hash, { replace: true });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  return (
    <>
      <div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <ScrollToTop />
        <CallAndWhatsapp />
        {/* <TopHeader /> */}
        <BottamHeader />
        <MobileFooter />
        <Routes location={location} key={location.pathname}>
          {RouteData?.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <TawkTo />
        <Footer />
      </div>
    </>
  );
}

export default App;
